import React, { PropsWithChildren, useEffect } from 'react'

import { useMediaQuery } from '@mui/material'
import { useEditor } from '@craftjs/core'
import { useLanguage } from '../../contexts/RecipientContext'
import './LandingPage.scss'

export const LandingPage = ({background, children}: PropsWithChildren<{bleed?: boolean, background: string}>) => {
  const mobile = useMediaQuery('(max-width:500px)')
  const {language, defaultLanguage, setDefaultLanguage, setLanguage} = useLanguage()
  const {root} = useEditor((state) => ({
    root: state.nodes.ROOT
  }))

  useEffect(() => {
    const default_lang = root?.data?.props?.default_lang || 'US'
    if(default_lang !== defaultLanguage) {
      setDefaultLanguage(default_lang)
    }

    const queryParams = new URLSearchParams(window.location.search)
    const selected_language = queryParams.get('lang') || default_lang // give priority to query params that is in url
    if(selected_language !== language) {
      setLanguage(selected_language)
    }
  }, [])

  return <div className={`dm-edit-landing dm-edit-landing--live ${mobile ? 'dm-edit-landing--mobile' : ''}`}
    style={{background}}>
    { children }
  </div>
}

LandingPage.craft = {
  displayName: 'LandingPage'
}
